import React from 'react'
import log from 'loglevel'
import { Dropdown } from 'react-bootstrap'
import { E2E_IDS } from 'src/Utils/testIds'
import { RISK_TREATMENT } from '@trustero/trustero-api-web/lib/risk/risk_pb'
import { useHasRequiredPermissions } from 'src/app/AppAuth/AppAuth.hooks'
import { PERMISSIONS } from 'src/config/roleConfig'
import {
  FilterDropdownItem,
  FilterDropdownToggle,
} from 'src/components/Reusable/IndexPage/FilterBar/FilterBar.styles'
import { useCreateOrUpdateRisks, useRisk } from '../risks.hooks'
import {
  RISK_TREATMENT_DROPDOWN,
  RISK_TREATMENT_LABEL,
} from '../risks.constants'

export const RisksTreatmentMenu = ({
  riskId,
}: {
  riskId: string
}): JSX.Element => {
  const hasEditPermissions = useHasRequiredPermissions([
    PERMISSIONS.READ,
    PERMISSIONS.EDIT,
  ])
  const createOrUpdateRisk = useCreateOrUpdateRisks()
  const risk = useRisk(riskId)

  if (!risk) {
    return <></>
  }

  const treatment = risk.getTreatment()
  const updateRisk = async (newTreatment: RISK_TREATMENT): Promise<void> => {
    try {
      risk.setTreatment(newTreatment)
      await createOrUpdateRisk([risk])
    } catch (err) {
      log.error(`Failed to update risk category for riskId: ${riskId}:`, err)
    }
  }

  return (
    <Dropdown
      id={E2E_IDS.RISK_CATEGORY_MENU}
      data-testid={E2E_IDS.RISK_CATEGORY_MENU}
      autoClose="outside"
      style={{ width: '100%' }}
    >
      <Dropdown.Toggle
        as={FilterDropdownToggle}
        disabled={!hasEditPermissions}
        style={{ width: '100%', height: '40px' }}
      >
        {RISK_TREATMENT_LABEL[treatment]}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {RISK_TREATMENT_DROPDOWN.map((item) => (
          <Dropdown.Item
            as={FilterDropdownItem}
            key={item.name}
            eventKey={item.value}
            onClick={() => updateRisk(item.value)}
          >
            {item.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}
